import axios from "axios";
import { getCurrentLocale } from "@/lib/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers["Accept-Language"] = getCurrentLocale();
  return config;
});
